const mediaItems = [
  {
    title: '《繁花》幕后花絮：王家卫的美学世界',
    dur: '15:28',
    views: '38.6万',
    img: 'https://readdy.ai/api/search-image?query=A%20behind%20the%20scenes%20film%20production%20set%20with%20warm%20cinematic%20lighting%2C%20camera%20equipment%20and%20directors%20chair%2C%20creative%20film%20making%20atmosphere%2C%20soft%20spotlight%20on%20set%2C%20professional%20movie%20production%2C%20warm%20amber%20tones%2C%20simple%20studio%20background&width=600&height=340&seq=tangxin-media-01&orientation=landscape',
  },
  {
    title: '年度悬疑剧大盘点：十部烧脑神作',
    dur: '22:41',
    views: '27.3万',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20detective%20desk%20with%20case%20files%20and%20warm%20lamp%20light%2C%20red%20string%20connections%20on%20corkboard%2C%20investigation%20mood%2C%20film%20noir%20aesthetic%2C%20warm%20brown%20and%20amber%20tones%2C%20simple%20dark%20background&width=600&height=340&seq=tangxin-media-02&orientation=landscape',
  },
  {
    title: '《地球脉动III》4K震撼片段精选',
    dur: '18:05',
    views: '42.1万',
    img: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20aerial%20view%20of%20migrating%20animals%20on%20savanna%20with%20golden%20sunset%20light%2C%20dramatic%20dust%20and%20warm%20atmosphere%2C%20epic%20nature%20documentary%20style%2C%20rich%20golden%20orange%20tones%2C%20simple%20natural%20background&width=600&height=340&seq=tangxin-media-03&orientation=landscape',
  },
  {
    title: '高分韩剧名场面合集：心动瞬间回顾',
    dur: '12:33',
    views: '31.8万',
    img: 'https://readdy.ai/api/search-image?query=A%20romantic%20cherry%20blossom%20avenue%20with%20warm%20spring%20sunlight%20filtering%20through%20petals%2C%20dreamy%20atmosphere%2C%20soft%20pink%20and%20golden%20tones%2C%20Korean%20drama%20aesthetic%2C%20cinematic%20wide%20shot%2C%20simple%20natural%20background&width=600&height=340&seq=tangxin-media-04&orientation=landscape',
  },
  {
    title: '科幻电影特效进化史：从模型到数字',
    dur: '25:10',
    views: '19.5万',
    img: 'https://readdy.ai/api/search-image?query=A%20futuristic%20digital%20workspace%20with%20holographic%20displays%20and%20warm%20ambient%20glow%2C%20sci-fi%20visual%20effects%20creation%20scene%2C%20computer%20screens%20showing%203D%20models%2C%20creative%20technology%20atmosphere%2C%20warm%20orange%20and%20teal%20tones%2C%20simple%20dark%20background&width=600&height=340&seq=tangxin-media-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="relative py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-semibold mb-4">
            精选内容
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            精选视频
          </h2>
          <p className="text-foreground-500 text-sm mt-2">精选解说、花絮与精彩片段，发现更多好内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer hover:bg-background-200/70 transition-colors duration-300"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 group-hover:bg-primary-600/90 transition-colors">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-background-50 text-[10px] font-medium whitespace-nowrap">
                  {item.dur}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}